import { useEffect, useRef } from 'react';

export const useAutoScroll = () => {
  const elementRef = useRef<HTMLSpanElement>(null);
  const scrollIntervalRef = useRef<NodeJS.Timeout | null>(null);
  const isScrollingRef = useRef(false);

  const startAutoScroll = () => {
    const element = elementRef.current;
    if (!element || isScrollingRef.current) return;

    const scrollWidth = element.scrollWidth;
    const clientWidth = element.clientWidth;

    if (scrollWidth <= clientWidth) return;

    isScrollingRef.current = true;
    let currentScroll = element.scrollLeft;
    const maxScroll = scrollWidth - clientWidth;
    const scrollStep = 1;
    const scrollDelay = 50;

    scrollIntervalRef.current = setInterval(() => {
      if (currentScroll >= maxScroll) {
        stopScrollOnly();
        return;
      }

      currentScroll += scrollStep;
      element.scrollLeft = currentScroll;
    }, scrollDelay);
  };

  const stopScrollOnly = () => {
    if (scrollIntervalRef.current) {
      clearInterval(scrollIntervalRef.current);
      scrollIntervalRef.current = null;
    }
    isScrollingRef.current = false;
  };

  const stopAndReset = () => {
    stopScrollOnly();

    if (elementRef.current) {
      elementRef.current.scrollTo({
        left: 0,
        behavior: 'smooth',
      });
    }
  };

  useEffect(() => {
    return () => {
      stopScrollOnly();
    };
  }, []);

  return {
    elementRef,
    startAutoScroll,
    stopAndReset,
  };
};
